import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Paragraph from 'components/Paragraph';
import BaseCard from 'apps/notificationCenter/views/baseCard';

import { StyledLink } from 'legacyComponents/styled/lib';

const FollowCard = props => {
  const { t, notification } = props;
  const { targetDisplayType, targetApp } = notification;
  if (!notification) return null;

  const message =
    targetApp && targetDisplayType !== 'Profile' && targetApp?.route ? (
      <Paragraph>
        {t('Started following')}{' '}
        <strong>
          <StyledLink {...targetApp.route}>
            {targetApp.name || targetApp.title}
          </StyledLink>
        </strong>
        .
      </Paragraph>
    ) : (
      <Paragraph>{t('Started following you.')}</Paragraph>
    );

  return <BaseCard notification={notification} message={message} />;
};

FollowCard.propTypes = {
  t: PropTypes.func,
  notification: PropTypes.object,
};

export default withNamespaces()(observer(FollowCard));
